// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sidebar-star[data-v-6ff8f4a5]{display:inline-flex;align-items:center;margin-left:8px}", ""]);
// Exports
module.exports = exports;
